export { FollowUpStatusDetail } from "./FollowUpStatusDetail";